<template lang="pug">
  #ch2footer
    .container-fluid
      .row.footer-content.d-flex
        .col-md-3.desktop
          a(href="https://datacivica.org/" target="_blank")
            img.logo(src="/assets/img/microsite/DC_white.png" alt="Data Cívica logo")
        .col-md-6.col-sm-12.neutral-text
          p.mb-0 Diseñado y desarrollado por Data Cívica
          hr
          p Ilustraciones de María Lumbreras. (IG: @la_lumbreras)
        .col-md-3.social.px-5.desktop
          a(href="https://twitter.com/datacivica" target="_blank")
            i.fab.fa-twitter
          a(href="https://www.facebook.com/datacivica/" target="_blank")
            i.fab.fa-facebook
          a(href="https://www.instagram.com/datacivica/" target="_blank")
            i.fab.fa-instagram
      .row.footer-content.mobile.mt-3
        .col-sm-6.mobile
          a(href="https://datacivica.org/" target="_blank")
            img.logo(src="/assets/img/microsite/DC_white.png" alt="Data Cívica logo")
        .col-sm-6.social.pl-5.mobile
          a(href="https://twitter.com/datacivica" target="_blank")
            i.fab.fa-twitter
          a(href="https://www.facebook.com/datacivica/" target="_blank")
            i.fab.fa-facebook
          a(href="https://www.instagram.com/datacivica/" target="_blank")
            i.fab.fa-instagram




</template>

<script>
export default {
  name: "Ch2Footer"
};
</script>

<style lang="scss">
#ch2footer {
  background-color: #0a1d59;
  padding: 10vh 5vw;
  .desktop {
    display: flex;
  }
  .footer-content {
    text-align: center;
    justify-content: center;
    align-items: center;
    .logo {
      max-width: 90%;
    }
    hr {
      width: 50%;
      height: 0px;
      border: none;
      border-top: 1px solid #ff6561;
      //margin: 0.5rem auto;
    }
    .social {
      justify-content: space-around;
      i {
        color: #fff;
        font-size: 1.5rem;
      }
    }
  }
}
// Small devices
@media (max-width: 420px) {
  #ch2footer {
    padding: 5vh 5vw;
    .desktop {
      display: none;
    }
    .mobile {
      display: flex;
    }
    .footer-content {
      text-align: center;
      justify-content: center;
      align-items: center;
      flex-wrap: nowrap;
      font-size: 0.8rem;
      hr {
        width: 80%;
      }
      .social {
        justify-content: space-around;
        i {
          color: #fff;
          font-size: 1rem;
        }
      }
    }
  }
}
</style>
